export const isValueZero = (value: unknown): boolean => {
  if (typeof value === 'number') {
    return value === 0
  }
  if (typeof value === 'string') {
    return parseFloat(value.replace(',', '.')) === 0 // строки типа '0a' тоже будут считаться нулевыми
  }
  return false
}
